import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2020 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

export class AbEntity {
  static getEntityServices(serviceIdentifier) {
    const serviceId = serviceIdentifier ? serviceIdentifier.id : "";
    let entityServices = AbEntity.serviceMap.get(serviceId);
    if (!entityServices) {
      throw new Error(`AbEntityServices was not initialized for ${serviceId ? `proxy ${serviceId}` : "default proxy"}`);
    }
    return entityServices;
  }

  /**
   * Returns true if AbEntity has a default registered instance of entity services.
   *
   * Note: in Metadata Hub, this will be the Metadata Hub server itself. For a proxied application
   * to use AbEntity, there must be at least one instance of entity proxy that is declared as the default.
   */
  static hasDefaultEntityServices() {
    return this.hasEntityServices();
  }
  static hasEntityServices(serviceIdentifier) {
    const serviceId = serviceIdentifier ? serviceIdentifier.id : "";
    return AbEntity.serviceMap.has(serviceId);
  }
  static registerEntityServices(entityServices, isDefault) {
    if (AbEntity.serviceMap.has(entityServices.serviceIdentifier.id)) {
      throw new Error(`Already initialized entity services for service "${entityServices.serviceIdentifier.id}". Call resetServices before re-initializing.`);
    }
    AbEntity.serviceMap.set(entityServices.serviceIdentifier.id, entityServices);
    if (isDefault && entityServices.serviceIdentifier.id !== "") {
      if (AbEntity.serviceMap.has("")) {
        throw new Error(`Already initialized default entity services for service "${entityServices.serviceIdentifier.id}". Call resetServices before re-initializing.`);
      }
      AbEntity.serviceMap.set("", entityServices);
    }
  }
  static resetServices() {
    AbEntity.serviceMap.clear();
  }
  static getEntityModelService(serviceIdentifier) {
    return AbEntity.getEntityServices(serviceIdentifier).entityModelService;
  }
  static getAllEntityServices() {
    return Array.from(AbEntity.serviceMap.values());
  }

  /**
   * @deprecated in favor of accessing the entity model from an entity service.
   */
  static getEntityModel() {
    return AbEntity.getEntityServices().entityModel;
  }

  /**
   * @deprecated in favor of using methods on getEntityServices
   */
  static getEntityUnsavedValuesStore() {
    return AbEntity.getEntityServices().unsavedValuesStore;
  }
}
_defineProperty(AbEntity, "serviceMap", new Map());
//# sourceMappingURL=AbEntity.js.map
